import { CampaignModelMapper } from "features/campaign/domain/models/campaignModel";

const InReviewCampaignModal = ({ data, onClose }: { data: CampaignModelMapper, onClose: () => void }) => {
    return <div className="flex flex-col items-center justify-center">
        <img src="/assets/icons/sand-timer.svg" alt="in-review" />
        <div className="gap-1 mt-8 flex flex-col items-center justify-center">
            <p className="font-inter font-medium text-[24px] leading-[120%] text-neutral-900 tracking-[-0.5%]">In Review</p>
            <span className="font-inter text-center font-normal text-[14px] leading-[20px] tracking-[-0.6%] text-neutral-700">Your campaign is being reviewed. This could take
                <span className="font-inter font-semibold text-[14px] leading-[20px] tracking-[-0.6%] text-neutral-700"> 1-2</span>{" "}
                days</span>
        </div>
    </div>;
};

export default InReviewCampaignModal;